import { HoneycombWebSDK } from '@honeycombio/opentelemetry-web';
import { getWebAutoInstrumentations } from '@opentelemetry/auto-instrumentations-web';
import { UserInteractionInstrumentation } from '@opentelemetry/instrumentation-user-interaction';
import { LongTaskInstrumentation } from '@opentelemetry/instrumentation-long-task';

const networkConfig = {
  ignoreNetworkEvents: true,
  propagateTraceHeaderCorsUrls: [/^https:\/\/datahub\..*\.efkt\.net/],
};

const sdk = new HoneycombWebSDK({
  endpoint: 'https://api.eu1.honeycomb.io/v1/traces', // Send to EU instance of Honeycomb
  apiKey: import.meta.env.VITE_HONEYCOMB_INGEST_API_KEY,
  serviceName: 'fe-webshop',
  instrumentations: [
    getWebAutoInstrumentations({
      '@opentelemetry/instrumentation-xml-http-request': networkConfig,
      '@opentelemetry/instrumentation-fetch': networkConfig,
      '@opentelemetry/instrumentation-document-load': networkConfig,
    }),
    new UserInteractionInstrumentation({
      eventNames: ['submit', 'click'],

      shouldPreventSpanCreation: (_, element, span) => {
        span.setAttribute('target.id', element.id);
        span.setAttribute('target.text', element.textContent ?? '');

        if (element.hasAttribute('data-testId')) {
          span.setAttribute('data-testId', element.getAttribute('data-testId') ?? '');
        }
      },
    }),
    new LongTaskInstrumentation({
      observerCallback: (span, info) => {
        span.setAttribute('location.pathname', window.location.pathname);
        span.setAttribute('longtask.duration', info.longtaskEntry.duration); //ms
        span.setAttribute('userAgent', navigator.userAgent);

        if (info.longtaskEntry.name === 'script') {
          span.setAttribute('task.type', 'script');
        } else if (info.longtaskEntry.name === 'layout') {
          span.setAttribute('task.type', 'layout');
        }

        if (info.longtaskEntry.duration > 100) {
          span.setAttribute('longtask.severity', 'high');
        } else {
          span.setAttribute('longtask.severity', 'medium');
        }
      },
    }),
  ],
  resourceAttributes: {
    /*
     Data in this object is applied to every trace emitted.
    "user.id": user.id,
    */
  },
});

!import.meta.env.DEV && sdk.start();
